import { useEffect, useState } from "react";
import "dayjs/locale/ja";
import { useGetNotificationsQuery, useReadNotificationMutation } from "../../services/notification";
import { List } from "antd";
import HrnAvatar from "../../components/HrnAvatar";
import dateUtils from "../../utils/dateUtils";
import { useNavigate } from "react-router-dom";
import ROUTES from "../../routes";
import { useTranslation } from "react-i18next";

const NotificationPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);
  const {
    data: notificationsResponse,
    isFetching: notificationsFetching,
    isSuccess: notificationsSuccess,
  } = useGetNotificationsQuery({ top: 1000, all: true });

  const [readNotification, readResult] = useReadNotificationMutation();

  useEffect(() => {
    if (notificationsSuccess && notificationsResponse?.data) {
      setNotifications(notificationsResponse.data);
    }
  }, [notificationsFetching]);

  const notificationClicked = async (item: any, index: number) => {
    await readNotification({ id: item.id }).unwrap();
    switch (item?.data?.type) {
      case "SubmitSurvey":
      case "SurveyFeedback":
        navigate(`/${item?.data?.survey?.id}/submissions?id=${item?.data?.submissionId}`);
        break;
      case "SubmitApplication":
      case "ApplicationFeedback":
        navigate(`/${item?.data?.applicationType?.id}/submissions?id=${item?.data?.submissionId}`);
        break;
      case "ImamSelfReg":
        navigate(`/${item?.data?.actor?.id}`);
        break;
      default:
        navigate(ROUTES.PATHS.NOTIFICATIONS);
        break;
    }
  };

  return (
    <List
      itemLayout="horizontal"
      dataSource={notifications}
      renderItem={(item: any, index: number) => (
        <List.Item key={index} style={{ cursor: "pointer", backgroundColor: (item?.read ? "#fff" : "transparent") }} onClick={() => notificationClicked(item, index)}>
          {item?.data?.type === "ImamSelfReg" ?
            <List.Item.Meta
              avatar={<HrnAvatar user={item?.data?.actor} size="large" />}
              title={<><a href={`mailto:${item?.data?.actor?.email}`}>{item?.data?.actor?.name}</a> from {item?.data?.actor?.country}</>}
              description={
                <>
                  <small>{dateUtils.llllFormat(item.dateTime)}</small>
                  <div>Registered as new imam. Please activate him.</div>
                </>
              }
            />
            :
            item?.data?.type === "SubmitSurvey" ?
              <List.Item.Meta
                avatar={<HrnAvatar user={item?.data?.actor} size="large" />}
                title={<><a href={`mailto:${item?.data?.actor?.email}`}>{item?.data?.actor?.name}</a> from {item?.data?.actor?.country}</>}
                description={
                  <>
                    <small>{dateUtils.llllFormat(item.dateTime)}</small>
                    <div>{`Submitted ${item?.data?.survey?.title} and it is pending for your approval.`}</div>
                  </>}
              />
              :
              item?.data?.type === "SurveyFeedback" ?
                <List.Item.Meta
                  avatar={<HrnAvatar user={item?.data?.actor} size="large" />}
                  title={<><a href={`mailto:${item?.data?.actor?.email}`}>{item?.data?.actor?.name}</a></>}
                  description={
                    <>
                      <small>{dateUtils.llllFormat(item.dateTime)}</small>
                      <div dangerouslySetInnerHTML={{ __html: t("{{status}} your <b>{{survey}}</b> submission.", { status: t(item?.data?.feedbackStatus), survey: t(item?.data?.survey?.title) }) }}></div>
                    </>}
                />
                :
                item?.data?.type === "SubmitApplication" ?
                  <List.Item.Meta
                    avatar={<HrnAvatar user={item?.data?.actor} size="large" />}
                    title={<><a href={`mailto:${item?.data?.actor?.email}`}>{item?.data?.actor?.name}</a> from {item?.data?.actor?.country}</>}
                    description={
                      <>
                        <small>{dateUtils.llllFormat(item.dateTime)}</small>
                        <div>{`Submitted ${item?.data?.applicationType?.title} bonus application and it is pending for your approval.`}</div>
                      </>}
                  />
                  :
                  item?.data?.type === "ApplicationFeedback" ?
                    <List.Item.Meta
                      avatar={<HrnAvatar user={item?.data?.actor} size="large" />}
                      title={<><a href={`mailto:${item?.data?.actor?.email}`}>{item?.data?.actor?.name}</a></>}
                      description={
                        <>
                          <small>{dateUtils.llllFormat(item.dateTime)}</small>
                          <div dangerouslySetInnerHTML={{ __html: t("{{status}} your <b>{{application}}</b> bonus application.", { status: t(item?.data?.feedbackStatus), application: item?.data?.applicationType?.title }) }}></div>
                        </>}
                    />
                    :
                    <List.Item.Meta
                      avatar={<HrnAvatar user={item?.data?.actor} size="large" />}
                      title={<><a href={`mailto:${item?.data?.actor?.email}`}>{item?.data?.actor?.name ?? "Admin"}</a></>}
                      description={
                        <>
                          <small>{dateUtils.llllFormat(item.dateTime)}</small>
                          <div>{item.message}</div>
                        </>} />
          }
        </List.Item>
      )}
    />
  );
};

export default NotificationPage;